import * as React from "react";
import {useState, useEffect} from "react";
import { jfetch } from "../../utils";
import { toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";

function FeaturedCourses(props) {



  return (
    <PageContainer>
      <ModernCard ta="left">
        <div>
          <h2>Featured Courses on Homepage</h2>
        </div>
        {props.courses.map((course) => {
          var d = new Date(course.created_at);
          return (
            <div key={course.id}>
              <a href={`/library/courses/${course.id}/edit`}>{course.title}</a> 
              <p style={{color:'black'}}>
                <small>
                  created: {(d.getMonth() + 1) + '/' + d.getDate() + '/' +  d.getFullYear()}
                </small>
              </p>
            </div>
          )
        })}
      </ModernCard>      
    </PageContainer>
  );
}

export default FeaturedCourses;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/FeaturedCourses.tsx